import MyDirect from "../../Component/TeamOverview/MyDirect"

const MyDirectReport = () => {
  return (
    <div className='page-body'>
      <MyDirect />
    </div>
  )
}

export default MyDirectReport